module.exports = __webpack_public_path__ + "img/file-icon_mov.4124f7c9.svg";